import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/strategy/')({

}).lazy(() => import('./index.lazy').then((d) => d.Route));
